<div fxLayout="column">
  <div
    fxFlex
    fxLayout="row"
    class="totalizers"
    fxLayoutAlign="space-between center"
    fxLayoutGap="10"
  >
  <div fxFlex="5"></div>
    <div fxFlex>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div
          fxFlex
          class="title"
        >
          TOTAL SELECIONADO
        </div>
        <div
          fxFlex
          class="value"
        >
          {{ totalizers.selectTotal }}
        </div>
      </div>
    </div>

    <div fxFlex>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div
          fxFlex
          class="title"
        >
          TOTAL CADASTRADO
        </div>
        <div
          fxFlex
          class="value"
        >
          {{ totalizers.registrationTotal }}
        </div>
      </div>
    </div>

    <div fxFlex>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div
          fxFlex
          class="title"
        >
          TOTAL ATIVOS
        </div>
        <div
          fxFlex
          class="value"
        >
          {{ totalizers.activeTotal }}
        </div>
      </div>
    </div>

    <div fxFlex=>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxFlex
        class="title"
      >
        TOTAL DESATIVADOS
      </div>
      <div
        fxFlex
        class="value"
      >
        {{ totalizers.deactiveTotal }}
      </div>
    </div>
  </div>

  <div fxFlex>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        fxFlex
        class="title"
        [ngClass.gt-xs]="'title-xs'"
        [ngClass.gt-md]="'title-md'"
        [ngClass.gt-lg]="'title-lg'"
      >
        TOTAL BLOQUEADOS
      </div>
      <div
        fxFlex
        class="value"
        [ngClass.gt-xs]="'value-xs'"
        [ngClass.gt-md]="'value-md'"
        [ngClass.gt-lg]="'value-lg'"
      >
        {{ totalizers.lockTotal }}
      </div>
    </div>
  </div>
</div>
